export default "__VITE_ASSET__qaWBnCGu__"